import _extends from "@babel/runtime/helpers/extends";
import { X } from "lucide-react";
import React from "react";
import { components } from "react-select";
import { RemoveButtonContainer } from "../../../../../Chip/components/RemoveButton";
import { jsx as _jsx } from "react/jsx-runtime";
var MultiValueRemove = components.MultiValueRemove;
function CustomMultiValueRemove(props) {
  return /*#__PURE__*/_jsx(RemoveButtonContainer, {
    children: /*#__PURE__*/_jsx(MultiValueRemove, _extends({}, props, {
      children: /*#__PURE__*/_jsx(X, {
        color: "currentColor",
        size: "1em"
      })
    }))
  });
}
export default CustomMultiValueRemove;